<template>
  <container-slot>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        append-icon="mdi-magnify"
        class="mt-5"
        color="#6fbee2"
        label="Search Username or Role"
        solo
        v-model="keyword"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="4" v-show="breakpoints.mdAndUp"> </v-col>

    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>
    <v-col cols="12" md="10" v-if="removeClicked">
      <v-alert
        :type="!error ? `success` : `error`"
        ref="alert"
        dismissible
        @input="defaultAlert"
        class="noMarg"
        v-show="removeClicked"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="1" v-if="removeClicked && breakpoints.mdAndUp">
    </v-col>

    <v-col cols="12">
      <v-card color="#6fbee2" dark elevation="5">
        <v-card-text>
          <v-data-table
            class="elevation-1 my-auto"
            light
            loading-text="Retrieving data... Please wait"
            :headers="headerUsers"
            :items="filterUsers"
            :items-per-page="5"
            :loading="$apollo.loading"
            :search="keyword"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ fDate(item.createdAt) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <td>
                <v-btn
                  color="blue-grey"
                  class="white--text"
                  @click="$router.push(`/user/edit/${item.id}`)"
                >
                  Edit
                  <v-icon right dark>mdi-square-edit-outline</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn
                  color="primary"
                  class="white--text"
                  @click="changePass(item.id)"
                >
                  Change Password
                  <v-icon right dark>mdi-pencil-lock</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn
                  color="error"
                  class="white--text"
                  @click="removeRow(item.id)"
                  v-if="!userSameAsCurrent(item.id)"
                >
                  Remove
                  <v-icon right dark>mdi-trash-can</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { users } from "@/utils/graphqlQuery";
import { news } from "@/utils/graphqlQuery";
import { editUser } from "@/utils/graphqlMutation";
import { lsUtils } from "@/utils/localStorageUtils";
import moment from "moment";

export default {
  apollo: {
    users: {
      query: users,
      update: (data) =>
        data.users.map((user, i) => ({
          ...user,
          no: i + 1,
          role: user.role ? user.role.roleName : "Deleted Role",
        })),
    },
  },
  components: {
    ContainerSlot,
  },
  computed: {
    breakpoints() {
      return {
        mdAndUp: this.$vuetify.breakpoint.mdAndUp,
        smAndDown: this.$vuetify.breakpoint.smAndDown,
      };
    },
    filterUsers() {
      return this.users.filter(
        (item) =>
          item.userName.toLowerCase().includes(this.keyword) ||
          item.role.toLowerCase().includes(this.keyword)
      );
    },
  },
  data() {
    return {
      error: false,
      keyword: "",
      msg: "",
      removeClicked: false,
      users: [],
      headerUsers: [
        { text: "No", field: "no", value: "no" },
        { text: "User Name", field: "userName", value: "userName" },
        { text: "Role", field: "role", value: "role" },
        { text: "Created At", field: "createdAt", value: "createdAt" },
        { text: "Actions", field: "actions", value: "actions" },
      ],
    };
  },
  name: "ListUser",
  methods: {
    changePass(id) {
      this.$router.push("/user/edit/change-password/" + id);
    },
    defaultAlert() {
      this.removeClicked = false;
      this.error = false;
      this.msg = "";
    },
    fDate(dateStr) {
      return moment(new Date(dateStr)).format("DD/MM/YYYY HH:mm:ss");
    },
    async removeRow(id) {
      const that = this;
      this.defaultAlert();
      const permission = confirm("Are you sure want to remove this user ?");
      if (permission) {
        const userObj = {
          id,
          isActive: 0,
        };
        const gqlUsers = users;
        const gqlNews = news;
        try {
          const { data } = await this.$apollo.mutate({
            mutation: editUser,
            variables: {
              userObj,
            },
            update: (store) => {
              const queries = [{ query: gqlUsers }, { query: gqlNews }];
              const mapQuery = queries.map((query) => {
                try {
                  const s = store.readQuery(query);
                  return s;
                } catch (err) {
                  return null;
                }
              });
              if (mapQuery.some((item) => !item)) {
                // eslint-disable-next-line no-console
                console.log("Users cache not found");
              } else {
                const queryUsers = mapQuery[0].users;
                const queryNews = mapQuery[1].news;

                const uUsers = queryUsers.filter((item) => item.id != id);
                store.writeQuery({
                  query: gqlUsers,
                  data: {
                    users: uUsers,
                  },
                });
                that.users = uUsers;

                const uNews = queryNews.map((item) => {
                  if (item.author && item.author.id == id) {
                    item.author = null;
                  }
                  return item;
                });
                store.writeQuery({
                  query: gqlNews,
                  data: {
                    news: uNews,
                  },
                });
              }
            },
          });
          const { success, msg } = data.editUser;
          if (!success) {
            throw new Error(msg);
          }
          this.error = false;
          this.msg = msg;
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.removeClicked = true;
        }
      }
    },
    userSameAsCurrent(id) {
      const userId = lsUtils.getItem("userToken").userData.id;
      return id == userId;
    },
  },
  title() {
    return "List User";
  },
};
</script>
